export default __webpack_public_path__ + "static/media/email-communication-invitation.9b446581.png";